import React, { useState } from "react";
import { Image } from "@heroui/react";
import { cn } from "../utils/cn";

interface AssetImageProps {
  identifier: string;
  className?: string;
  alt?: string;
  fallbackSrc?: string;
}

export const getMxTokenImg = (identifier?: string) => {
  if (!identifier) return "/images/icons/unknown-esdt.png";

  if (identifier.toUpperCase() === "EGLD")
    return "https://raw.githubusercontent.com/multiversx/mx-assets/master/identities/multiversx/logo.png";

  return `https://raw.githubusercontent.com/multiversx/mx-assets/master/tokens/${identifier}/logo.png`;
};

export const AssetImage: React.FC<AssetImageProps> = ({
  identifier,
  className = "w-8 h-8",
  alt,
  fallbackSrc,
}) => {
  const [imageError, setImageError] = useState(false);

  // Generate image URL based on identifier
  // This could be customized based on your asset URL pattern

  const imageUrl = getMxTokenImg(identifier);
  const displayAlt = alt || identifier;

  if (imageError && !fallbackSrc) {
    // Fallback to a generic token icon or placeholder
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-neutral-700 rounded-full text-white text-xs font-semibold",
          className
        )}
      >
        {identifier.slice(0, 2).toUpperCase()}
      </div>
    );
  }

  return (
    <Image
      src={imageError && fallbackSrc ? fallbackSrc : imageUrl}
      alt={displayAlt}
      className={cn("object-cover rounded-full", className)}
      onError={() => setImageError(true)}
      fallbackSrc={fallbackSrc}
    />
  );
};
